import api from '../config/axiosConfig';

export const ReportadasService = {
    get: async ({ token, vid }) => {
        try {
            const response = await api.get('/reportadas', {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReportadasService.get:', error);
            throw error;
        }
    },
    save: async ({ token, formData }) => {
        try {
            const response = await api.post('/reportadas', formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReportadasService.save:', error);
            throw error;
        }
    },
    disable: async ({ token, formData }) => {
        try {
            await api.put('/reportadas', formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en ReportadasService.disable:', error);
            throw error;
        }
    }
};
